'use client';

import { useCountryStore } from '@/src/lib/state-stores/currencyStore';
import usePrimeStore from '@/src/lib/state-stores/primeStore';
import useUserStore from '@/src/lib/state-stores/userStore';
import useWishListStore from '@/src/lib/state-stores/whishlistStore';
import { Prime } from '@/src/types/prime';
import { ProfileRequest } from '@/src/types/Profile';
import { TAllWishlist } from '@/src/types/wishlist';
import { useEffect, useRef } from 'react';
import Cookies from 'js-cookie';
import { updateCountryId, refreshServerData } from '@/src/lib/actions';

type Props = {
  wishlists: TAllWishlist[];
  prime: Prime;
  user?: ProfileRequest | null;
  countryId?: string;
};

const GlobalStore = ({ wishlists, prime, user }: Props) => {
  const { setWishlist } = useWishListStore();
  const { setPrime } = usePrimeStore();
  const { setUser } = useUserStore();
  const { setCountryId, countryId } = useCountryStore();

  const isInitialized = useRef(false);

  useEffect(() => {
    const syncLocationAndCookies = async () => {
      const hasLocation = Cookies.get('locationDetails');
      const hasCountry = Cookies.get('countryId');

      if (hasLocation && hasCountry) {
        if (countryId?.toString() !== hasCountry) {
          setCountryId(hasCountry as any);
        }
        return;
      }

      if (hasLocation && !hasCountry) {
        const res = await updateCountryId();
        if (res?.success) {
          setCountryId(res.countryId as any);
          await refreshServerData();
        }
      }
    };

    syncLocationAndCookies();
  }, [setCountryId, countryId]);

  useEffect(() => {
    if (!isInitialized.current) {
      if (user) setUser(user);
      if (wishlists && wishlists.length > 0) setWishlist(wishlists);
      if (prime) setPrime(prime);

      isInitialized.current = true;
    }
  }, [wishlists, prime, user, setWishlist, setPrime, setUser]);

  return null;
};

export default GlobalStore;
